import React from "react";
import { useSelector } from "react-redux";
import { ArrowRightIcon, Body1, Body2 } from "@activecollab/components";
import PropTypes from "prop-types";
import { v4 } from "uuid";
import { SUGGESTION } from "~/components/tasks/SuggestWizard/suggestionUtils";
import StepLoader from "~/pages/GettingStarted/StepLoader";
import { useProjectTemplates } from "~/repository/usePredefinedProjectTemplates";
import { getLoggedUserId } from "~/store/selectors/selector.users";
import { assets_url } from "~/utils/urls";

export const ProjectTemplates = ({ onTemplateClick }) => {
  const { data: templates, isFetched } = useProjectTemplates();
  const loggedUserId = useSelector(getLoggedUserId);

  return !isFetched ? (
    <StepLoader />
  ) : (
    <div className="tw-flex tw-flex-col tw-gap-2">
      {templates?.map((t) => {
        return (
          <div
            key={t.name}
            className="tw-flex tw-justify-between tw-py-4 tw-px-2 hover:tw-bg-theme-200 tw-rounded-lg tw-cursor-pointer tw-gap-6"
            onClick={() => {
              onTemplateClick({
                name: t.name,
                task_lists: t.task_lists.map((tl) => {
                  return {
                    ...tl,
                    id: v4(),
                    tasks: tl.tasks.map((t) => {
                      return {
                        ...t,
                        id: v4(),
                        variant: SUGGESTION,
                        assignee_id: loggedUserId,
                        estimate: `${t.estimate}`,
                      };
                    }),
                  };
                }),
              });
            }}
          >
            <div className="tw-flex tw-gap-6">
              <img
                alt="Template icon"
                src={`${assets_url}/onboarding/images/UseATemplateIcon.png`}
                className="tw-w-12 tw-h-12 sm:tw-w-16 sm:tw-h-16"
              />
              <div className="tw-flex tw-flex-col tw-justify-center tw-gap-0.5">
                <Body1 weight="bold">{t.name}</Body1>
                <Body2>{t.description}</Body2>
              </div>
            </div>
            <div className="tw-flex tw-items-center">
              <ArrowRightIcon />
            </div>
          </div>
        );
      })}
    </div>
  );
};

ProjectTemplates.propTypes = {
  onTemplateClick: PropTypes.func.isRequired,
};
